import { Dispatch } from 'redux'
import { DepartmentAction, DepartmentState } from './types'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../store'

type UseDepartment = {
  departmentState: DepartmentState
  departmentDispatch?: Dispatch<DepartmentAction>
}

export const useDepartment = (): UseDepartment => {
  const departmentState = useSelector<ApplicationState, DepartmentState>(rootReducer => rootReducer.departmentReducer)
  const departmentDispatch = useDispatch<Dispatch<DepartmentAction>>()
  return { departmentState, departmentDispatch }
}
